// Indicadores discretos de modo lectura para admin (no superadmin).
// - Pill chica arriba a la derecha del título solo en rutas de config crítica
// - Badge en sidebar muestra "👁️ Modo lectura" permanente
// Para superadmin: nada (invisible).

import { useAuth } from '../lib/AuthContext'

// Pill arriba del título — aparece SOLO en pantallas de config crítica.
export default function SoloLecturaBanner() {
  const { isSuperadmin, role, loading } = useAuth()
  if (loading || isSuperadmin || role !== 'admin') return null

  return (
    <>
      <span className="solo-lectura-pill" title="Como admin podés ver esta pantalla pero no modificar nada. Pedile a un superadmin (Nico o Roberto) si necesitás cambios.">
        👁️ solo lectura
      </span>
      <style>{`
        .solo-lectura-pill {
          display: inline-flex; align-items: center; gap: 5px;
          background: #fef3c7; color: #78350f;
          border: 1px solid #fbbf24;
          font-size: 11px; font-weight: 700;
          padding: 3px 10px; border-radius: 999px;
          margin-left: 12px; vertical-align: middle;
          letter-spacing: 0.01em;
          cursor: help;
        }
      `}</style>
    </>
  )
}

// Hook simple para pantallas que quieren saber si están en modo lectura.
// Útil para esconder botones específicos: {!soloLectura && <button>...</button>}
export function useSoloLectura() {
  const { isSuperadmin, role } = useAuth()
  return role === 'admin' && !isSuperadmin
}
